import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/** Horizontal row for filters/segmented controls (left) and actions (right). Wraps on mobile. */
export function Toolbar({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex flex-wrap items-center gap-2', className)} {...rest} />;
}

/** Pushes following toolbar items to the right edge. */
export function ToolbarSpacer() {
  return <div className="flex-1" aria-hidden="true" />;
}
